import { generateAuthHeader } from "../../../commonfunctions/authentication";

const getCurrentOrder = async () => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_HALFBACK_ROOT_API}/orders/current_order`,
      generateAuthHeader(),
    );
    if (res.ok) {
      const data = await res.json();
      return data;
    } else {
      const error = await res.text();
      throw error;
    }
  } catch (error) {
    throw error;
  }
};

export default getCurrentOrder;
